import { EffectScheduler } from "@tldraw/state";
import { useEffect, useMemo, useRef } from "react";
function useReactor(name, reactFn, deps = []) {
  const raf = useRef(-1);
  const scheduler = useMemo(
    () => new EffectScheduler(name, reactFn, {
      scheduleEffect: (cb) => {
        const rafId = requestAnimationFrame(cb);
        raf.current = rafId;
        return rafId;
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps
  );
  useEffect(() => {
    scheduler.attach();
    scheduler.execute();
    return () => {
      scheduler.detach();
      cancelAnimationFrame(raf.current);
    };
  }, [scheduler]);
}
export {
  useReactor
};
//# sourceMappingURL=useReactor.mjs.map
